import * as valibot from 'valibot';

/**
 * A starred stop, persisted so the Departures tab can re-open it on the next
 * visit. `extId` is HAFAS's stable identifier; the coord+name are cached so
 * the sidebar can render the list without a fresh resolve round-trip.
 */
export interface FavoriteStop {
  extId: string;
  name: string;
  lat: number;
  lon: number;
  /** UNIX ms of the most recent star action for this stop; used only for MRU ordering. Re-adding an already-starred stop bumps this value. */
  starredAt: number;
}

/** LocalStorage key for the persisted favorites list. */
export const FAVORITES_KEY = 'router.favorites.v3';

/** Runtime schema mirroring {@link FavoriteStop}; enforces non-empty strings and finite numeric fields (starredAt included, so NaN payloads are rejected). */
const FavoriteStopSchema = valibot.object({
  extId: valibot.pipe(valibot.string(), valibot.minLength(1)),
  name: valibot.pipe(valibot.string(), valibot.minLength(1)),
  lat: valibot.pipe(valibot.number(), valibot.finite()),
  lon: valibot.pipe(valibot.number(), valibot.finite()),
  starredAt: valibot.pipe(valibot.number(), valibot.finite()),
});

/** True when `item` is a well-formed {@link FavoriteStop}. */
export function isFavoriteStop(item: unknown): item is FavoriteStop {
  return valibot.is(FavoriteStopSchema, item);
}
